<template>
  <div style="position: absolute; z-index: 9999">
    <beautiful-chat
      :participants="participants"
      :titleImageUrl="titleImageUrl"
      :onMessageWasSent="onMessageWasSent"
      :messageList="messageList"
      :newMessagesCount="newMessagesCount"
      :isOpen="isChatOpen"
      :close="closeChat"
      :open="openChat"
      :showEdition="true"
      :showDeletion="true"
      :deletionConfirmation="true"
      :showTypingIndicator="showTypingIndicator"
      :showLauncher="true"
      :showCloseButton="true"
      :colors="colors"
      :alwaysScrollToBottom="alwaysScrollToBottom"
      :disableUserListToggle="false"
      :messageStyling="messageStyling"
      @onType="handleOnType"
      @edit="editMessage"
      class="z-top"
    />
  </div>
</template>

<script>
import firebase from "firebase";
import { store } from "../../store/store";

export default {
  data() {
    return {
      anonid: "",
      participants: [
        {
          id: "support",
          name: "Suport",
          imageUrl:
            "https://avatars3.githubusercontent.com/u/37018832?s=200&v=4",
        },
      ], // the list of all the participant of the conversation. `name` is the user name, `id` is used to establish the author of a message, `imageUrl` is supposed to be the user avatar.
      titleImageUrl:
        "https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png",
      messageList: [
        {
          type: "text",
          author: `Suport`,
          data: { text: `Salut! Cu ce te putem ajuta? Te rog sa ne lasi un numar de telefon sau o adresa de mail pentru a te putea contacta.`, id: 0 },
        },
      ], // the list of the messages to show, can be paginated and adjusted dynamically
      newMessagesCount: 0,
      isChatOpen: false, // to determine whether the chat window should be open or closed
      showTypingIndicator: "", // when set to a value matching the participant.id it shows the typing indicator for the specific user
      colors: {
        header: {
          bg: "#2073cf",
          text: "#ffffff",
        },
        launcher: {
          bg: "#2073cf",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "#15ba11",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#2073cf",
          text: "#ffffff",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      }, // specifies the color scheme for the component
      alwaysScrollToBottom: false, // when set to true always scrolls the chat to the bottom when new events are in (new message, user starts typing...)
      messageStyling: true, // enables *bold* /emph/ _underline_ and such (more info at github.com/mattezza/msgdown)
    };
  },
  methods: {
    GetUserMessages() {
      //Get chat history
      if (store.state.user.loggedIn && store.state.user.data != null) {
        const userID = firebase.auth().currentUser.uid;
        const database = firebase.database().ref();
        database.child("messages/" + userID).on("value", (messages) => {
          if (messages.val()) {
            this.messageList = messages.val().messageList;
            // console.log(messages.val().messageList);
          }
        });
      } else {
        // console.log("STORE DATA1", store.state.user.data);
        if (store.state.user.data == null) {
          this.anonid = "anonim-" + Math.round(Math.random() * 10000);
          store.commit({
            type: "SET_USER",
            data: {
              uid: this.anonid,
            },
          });
        } else {
          this.anonid = store.state.user.data.uid;
        }

        const database = firebase.database().ref();
        database.child("messages/" + this.anonid).on("value", (messages) => {
          if (messages.val()) {
            this.messageList = messages.val().messageList;
            // console.log(messages.val().messageList);
          }
        });
      }
    },
    sendMessage(text) {
      if (text.length > 0) {
        this.newMessagesCount = this.isChatOpen
          ? this.newMessagesCount
          : this.newMessagesCount + 1;
        this.onMessageWasSent({
          author: "support",
          type: "text",
          data: { text, id: 1 },
        });
      }
    },
    onMessageWasSent(message) {
      // called when the user sends a message
      message.data.id = this.messageList.length;
      // console.log(message.data.id);
      this.messageList = [...this.messageList, message];
      if (store.state.user.loggedIn) {
        const userID = firebase.auth().currentUser.uid;
        const db = firebase.database().ref();

        db.child("messages/" + userID).update({
          messageList: this.messageList,
        });
        db.child("adminchat/" + userID).update({ state: true });
      } else {
        const userID = this.anonid;
        const db = firebase.database().ref();

        db.child("messages/" + userID).update({
          messageList: this.messageList,
        });
        db.child("adminchat/" + userID).update({ state: true });
      }
    },
    openChat() {
      // called when the user clicks on the fab button to open the chat
      this.GetUserMessages();
      this.isChatOpen = true;
      this.newMessagesCount = 0;
    },
    closeChat() {
      // called when the user clicks on the botton to close the chat
      this.isChatOpen = false;
    },
    handleScrollToTop() {
      // called when the user scrolls message list to top
      // leverage pagination for loading another page of messages
    },
    handleOnType() {
      // console.log("Emit typing event");
    },
    editMessage(message) {
      const m = this.messageList.find((m) => m.id === message.id);
      m.isEdited = true;
      m.data.text = message.data.text;
    },
  },
};
</script>

<style>
</style>